import { useInView } from '../../../hooks/useInView';

export default function TrustStrip() {
  const { ref, inView } = useInView();

  const features = [
    { icon: 'ri-stack-line', title: 'Structured AI Architecture', description: 'Engineered frameworks built for sustainable, long-term growth.' },
    { icon: 'ri-shield-check-line', title: 'Compliance-Aware Systems', description: 'Industry-specific security and regulatory standards, built in.' },
    { icon: 'ri-line-chart-line', title: 'Revenue & Workflow Optimization', description: 'Measurable improvements in efficiency and conversion.' },
    { icon: 'ri-star-line', title: 'Premium Client Experience', description: 'Seamless, automated interactions that elevate your brand.' },
  ];

  return (
    <section className="bg-white py-32">
      <div className="max-w-6xl mx-auto px-8">
        <div ref={ref} className={`text-center mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-teal-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Our Standards</p>
          <h2 className="font-serif text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
            Built for Businesses That<br />Operate at a Higher Standard.
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-px bg-slate-100 rounded-2xl overflow-hidden">
          {features.map((f, i) => (
            <div
              key={i}
              className={`bg-white p-10 transition-all duration-700 hover:bg-slate-50 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${f.icon} text-2xl text-teal-600`} />
              </div>
              <h3 className="font-semibold text-slate-900 text-base mb-3 leading-tight">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
